// extracted by mini-css-extract-plugin
export default {"bathroomMsg":"BathroomQuantitySelect_bathroomMsg__RbTMd"};